import React from "react";
import _ from "lodash";

import ModalWrapper from "components/common/ModalWrapper";
import ModalFooter from "components/common/ModalFooter";

import TextAreaEditorControl from "components/common/TextAreaEditorControl";
import { MESSAGE } from "constants/Message";
import { JSON_FORMAT_MSG } from "helpers/JsonCheck";
import { cleanupRule } from "helpers/CustomUprFirstLookUtils";

class CustomRuleJsonEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      msg: [],
    };

    this.editorRef = React.createRef();

    this.handleMsgSet = this.handleMsgSet.bind(this);
    this.handleSyncErrMsg = this.handleSyncErrMsg.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
  }

  handleMsgSet(msgType) {
    this.setState({ msg: [JSON_FORMAT_MSG[msgType], msgType] });
  }

  handleSyncErrMsg({ result }) {
    if (result) {
      this.handleMsgSet(MESSAGE.SUCCESS);
    } else {
      this.handleMsgSet(MESSAGE.ERROR);
    }
  }

  handleConfirm() {
    const { msg } = this.state;
    const { handleConfirm, handleValidate } = this.props;

    if (_.isNil(handleConfirm) || _.isNil(handleValidate)) {
      return;
    }

    if (_.isNil(this.editorRef.current)) {
      return;
    }

    const data = this.editorRef.current.getData();

    if (_.isNil(data)) {
      this.handleMsgSet(MESSAGE.ERROR);
      return;
    }

    const validateResult = handleValidate(data);

    if (
      (msg[1] === MESSAGE.WARNING && _.isEqual(validateResult, msg)) ||
      validateResult.length === 0
    ) {
      handleConfirm({ rule: cleanupRule(data) });
    } else {
      this.setState({ msg: validateResult });
    }
  }

  render() {
    const { handleCloseModal, currentRule } = this.props;
    const { msg } = this.state;

    return (
      <ModalWrapper
        isOpen={true}
        showCloseFooter={false}
        handleClose={handleCloseModal}
        title={{
          label: "Edit Rule ",
          highlight: `${currentRule.id} - ${currentRule.name}`,
        }}
        width="50%"
        customOverlayStyle={{ zIndex: 100 }}
      >
        <div className="mb-4">
          <TextAreaEditorControl
            ref={this.editorRef}
            data={currentRule}
            handleSyncErrMsg={this.handleSyncErrMsg}
          ></TextAreaEditorControl>
        </div>

        <ModalFooter
          msg={msg}
          switchToCloseOnSuccess={false}
          confirmText="Save"
          onCancel={handleCloseModal}
          onConfirm={this.handleConfirm}
        />
      </ModalWrapper>
    );
  }
}

export default CustomRuleJsonEditModal;
